import React from 'react';
import type { EpicDetail } from '../../../../../../shared/types/epics';
import { PRTrackingCard } from '../../../../components/epicDetail/PRTrackingCard';
import { CutoverBoard } from '../../../../components/epicDetail/CutoverBoard';
import { EpicDiffSection } from '../diff/EpicDiffSection';

export const ChangesTab: React.FC<{
  epic: EpicDetail;
  epicId: string;
  onOpenTranscript: (storyId: string, agentType: string, taskArn?: string | null) => void;
}> = ({ epic, epicId, onOpenTranscript }) => {
  const watches = (epic.prWatches && epic.prWatches.length > 0)
    ? epic.prWatches
    : (epic.prWatch ? [epic.prWatch] : []);
  const hasReview = watches.length > 0 || !!epic.prUrl;
  const open1 = (storyId: string, agentType: string, taskArn?: string | null) =>
    onOpenTranscript(storyId, agentType, taskArn);

  return (
    <div className="space-y-5">
      <EpicDiffSection epicId={epicId} />

      {/* Review phase — one card per PR, its pr-fix / pr-resolution runs nested. */}
      {hasReview && (
        watches.length <= 1 ? (
          <PRTrackingCard prWatch={epic.prWatch ?? watches[0] ?? null} prUrl={epic.prUrl} epicId={epicId} onOpenTranscript={open1} />
        ) : (
          <div className="space-y-3">
            {watches.map((w) => (
              <div key={w.repo ?? String(w.prNumber)}>
                {w.repo && (
                  <div className="mb-1 font-mono text-xs text-gray-500">{w.repo}</div>
                )}
                <PRTrackingCard prWatch={w} prUrl={w.prUrl} epicId={epicId} onOpenTranscript={open1} />
              </div>
            ))}
          </div>
        )
      )}

      {/* FORGE-276 M1: runtime-strangler cutover board — self-renders only
          for a migration epic with seeded CUTOVER# rows (null otherwise). */}
      <CutoverBoard epicId={epicId} />
    </div>
  );
};
